export type ReferenceWithPage = {
  metadata?: Record<string, unknown> | null;
};

/** Page of a PDF or flipbook source (1-based); `null` when the source has none or it is not valid. */
function getReferencePage(reference: ReferenceWithPage): number | null {
  const page = reference.metadata?.page;

  return typeof page === 'number' && Number.isInteger(page) && page > 0 ? page : null;
}

export default getReferencePage;
